/*
 * @Author: Hyman Choi
 * @Date: 2021-01-11 08:35:55
 * @LastEditTime: 2021-01-13 16:24:02
 * @LastEditors: Hyman Choi
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\utils\validate.js
 */
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  // const valid_map = ['admin', 'editor', 'user']
  // return valid_map.indexOf(str.trim()) >= 0
  const reg = /^.*$/
  return reg.test(str)
}


//是否为空
export function isVaild(val) {
    if (val != null && typeof (val) != "undefined" && val !== "" && val != "undefined" && val != "null") {
        return true
    } else {
        return false
    }
}
